import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {
    IncidentSubtype,
    IncidentType,
    TrendAnalyzeResponse,
    TrendApiService,
    TrendType,
} from '@npck/af-frontend-api';
import {DATE_SERVER_FORMAT, Spinner} from '@npck/libs/commons';
import {SnackbarService} from '@npck/libs/ui-kit';
import dayjs from 'dayjs';
import {delay, finalize} from 'rxjs/operators';
import {DateRangeForm} from '../../../../../components/date-range-picker-field/date-range-picker-field.component';

@Component({
    selector: 'af-trend-create-dialog',
    standalone: false,
    templateUrl: './create-trend-dialog.component.html',
})
export class CreateTrendDialogComponent implements OnInit, OnDestroy {
    Spinner = Spinner;
    form: FormGroup<CreateTrendGenerationForm>;
    isTrendGenerationStarted: boolean;
    maxDate = new Date();
    currentPeriodEndDate = dayjs();
    currentPeriodStartDate = this.currentPeriodEndDate.subtract(7, 'day');

    constructor(
        public dialogRef: MatDialogRef<CreateTrendDialogComponent>,
        private formBuilder: FormBuilder,
        private trendApiService: TrendApiService,
        private snackBarService: SnackbarService,
    ) {
        this.form = this.formBuilder.group({
            trendType: new FormControl(null, [Validators.required]),
            incidentType: new FormControl(null, [Validators.required]),
            fraudType: new FormControl(null, [Validators.required]),
        });
        this.form.addControl('periodRange', this.formBuilder.group({}));
    }

    ngOnInit(): void {
        this.isTrendGenerationStarted = false;
    }

    ngOnDestroy(): void {
        this.isTrendGenerationStarted = false;
    }

    submitTrendGeneration(): void {
        this.Spinner.show('trendGenerationLoading');
        if (!this.isTrendGenerationStarted) {
            this.isTrendGenerationStarted = true;
        }

        this.trendApiService.createTrendAnalysis({
            periodFrom: dayjs(this.form.controls.periodRange?.controls?.dateFrom?.value).format(DATE_SERVER_FORMAT),
            periodTo: dayjs(this.form.controls.periodRange?.controls?.dateTo?.value).format(DATE_SERVER_FORMAT),
            trendType: this.form.controls.trendType.value,
            incidentType: this.form.controls.incidentType.value,
            fraudType: this.form.controls.fraudType.value,
        }).pipe(delay(500), finalize(() => this.Spinner.hide('trendGenerationLoading'))).subscribe({
            next: (response: TrendAnalyzeResponse) => {
                this.dialogRef.close(response);
                if (response.status === 'ERROR') {
                    this.snackBarService.showSnackBar(
                        response.errorStatus == 'CONFLICT'
                            ? 'i18n_af_snackBarMessageFailedWithConflictToAnalyzeTrend'
                            : 'i18n_af_snackBarMessageFailedToAnalyzeTrend',
                        'error',
                        false
                    );
                } else {
                    this.snackBarService.showSnackBar('i18n_af_snackBarMessageTrendAnalyzeStarted');
                }
            },
            error: err => {
                this.dialogRef.close();
                this.snackBarService.showSnackBar(
                    'i18n_af_snackBarMessageFailedToAnalyzeTrend',
                    'error',
                    false
                );
            }
        });
    }
}

interface CreateTrendGenerationForm {
    periodRange?: FormGroup<DateRangeForm>
    trendType: FormControl<TrendType>;
    incidentType: FormControl<IncidentType>;
    fraudType: FormControl<IncidentSubtype>;
}
